module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Grand, ténébreux et sans visa")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Par Bru Baker")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Décisions hâtives sur idées malencontreuses rapprochent le Portugais Mateus Fontes et l’homme d’affaires Crawford Hargrave au poste de frontière canadien.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mateus se retrouve dans une impasse. Avec un permis de tourisme qui expire sous peu, son entrée au Canada lui est refusée et on rejette sa demande pour repasser la frontière des États-Unis. En inventant de toute pièce leurs prétendues fiançailles, Crawford pense avoir réglé le problème, et cela fonctionne, jusqu’à ce qu’ils apprennent qu’ils doivent réellement se marier avant de pouvoir rentrer aux États-Unis. Mais Crawford s’est déjà fait avoir une fois par le mariage et il est déterminé à ne pas reproduire la même erreur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Aucun d’entre eux ne s’attend à ce que de réels sentiments naissent de ce mariage blanc, et c’est pourtant ce qui est sur le point d’arriver. Ils devront apprendre à être honnêtes l’un envers l’autre s’ils espèrent que cela fonctionne entre eux, chose particulièrement difficile lorsque leur mariage entier est basé sur des mensonges.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b970d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0